
import React, { useEffect, useMemo, useState } from "react";

const COVER_VERSION = "v2";

// Map featureKey to image number (1-10) as per user mapping
const featureKeyToImageNum = {
  "symptom-checker": 1,
  "doctor-consult": 2,
  epharmacy: 3,
  "health-wallet": 4,
  remote: 5,
  "my-health-records": 6,
  "lab-tests": 7,
  "learn-health": 8,
  "emergency-response": 9,
  "campaigns": 10,
};

function getUserStorageId() {
  try {
    const userRaw = localStorage.getItem("user");
    if (userRaw) {
      const user = JSON.parse(userRaw);
      if (user?._id) return user._id;
    }
  } catch {}
  return localStorage.getItem("userId") || "guest";
}

export default function QuickActionCoverGate({ featureKey, children }) {
  const [seen, setSeen] = useState(null);
  const storageKey = useMemo(() => {
    const userId = getUserStorageId();
    return `quick_action_cover_seen_${COVER_VERSION}_${featureKey}_${userId}`;
  }, [featureKey]);

  useEffect(() => {
    const hasSeen = localStorage.getItem(storageKey) === "true";
    setSeen(hasSeen);
  }, [storageKey]);

  if (seen === null) return null;
  if (seen) return children;

  // Pick the image based on featureKey (default to 1.png)
  const imgNum = featureKeyToImageNum[featureKey] || 1;
  const imgSrc = require(`./icon-assesst/${imgNum}.png`);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        margin: 0,
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        cursor: "pointer",
      }}
      onClick={() => {
        localStorage.setItem(storageKey, "true");
        setSeen(true);
      }}
    >
      <img
        src={imgSrc}
        alt="cover"
        style={{
          width: "100vw",
          height: "100vh",
          objectFit: "cover",
          display: "block",
          userSelect: "none",
        }}
        draggable={false}
      />
    </div>
  );
}
